import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SeasonService } from '../season.service';
import { SyncedStorage } from '../../app-commons/synced-storage/synced-storage';
import { shareReplay, switchMap } from 'rxjs/operators';
import { RacePlan } from '../race-plan/race-plan';

@Injectable({
  providedIn: 'root'
})
export class RacesService {

  public readonly racePlans$$ = this.seasonService.syncedStorage$.pipe(
    switchMap((syncedStorage) => syncedStorage.getDocsWatcher<RacePlan>('RacePlan')),
    shareReplay({
      refCount: true,
      bufferSize: 1
    })
  );

  public readonly racePlans$ = SyncedStorage.watchDocs$<RacePlan>(this.racePlans$$);

  constructor(
    private readonly seasonService: SeasonService
  ) {
  }

  racePlan$(id: number | string): Observable<SyncedStorage.Doc<RacePlan>> {
    return SyncedStorage.watchDoc$<RacePlan>(this.racePlans$$, 'RacePlan', id);
  }
}
